<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vxueLP/images/e9781439623909_cover.jpg?1684515805016" alt="This image is the cover for the book Billerica, Postcard History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Billerica, Postcard History
      </h1>
      <p class="bookDescription body article font2">
        <p>From its pre-Colonial origins to the hustle and bustle of today, Billerica has remained a thriving village with something for everyone. Surrounded by lakes, rivers, and footpaths that became the building blocks of the state�s road system, Billerica�s history reflects the growth trends of a young nation�a history steeped in courage, independence, prosperity, and celebration. Originally the Shawshin Wilderness, the fledgling settlement took the name Billerica and was incorporated as a town in 1655. The territory initially included lands that would become parts of Bedford, Tewksbury, Wilmington, and Carlisle. For the next three centuries, farmers, weavers, merchants, millers, and craftsmen sought out Billerica for its agricultural opportunity, potential waterpower, recreational attractions, and strategic travel routes.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David A. D'Apice
      </h2>
      
      <p class="authorDescription body article">David A. D�Apice is a historian, marketing communications professional, and collector of rare historic documents. His efforts to preserve Billerica�s history include the restoration of several period buildings in town and the digitization of 1,200 glass-plate negatives and nearly 2,000 pages of the town�s earliest historical records.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69549b55